import React from "react";
import "./styles.scss";

const SkipButton = ({ buttonText, onClick }) => {
  return (
    <>
      {buttonText ? (
        <div className="skip-btn" onClick={onClick}>
          {buttonText}
        </div>
      ) : null}
    </>
  );
};

export default SkipButton;
